module.exports = "/img/not-found.png?972fd2c1478f016ce7c0d37cea1508a5";


//////////////////
// WEBPACK FOOTER
// ./resources/assets/img/identity/not-found.png
// module id = EtaB
// module chunks = 46